<script setup>
// A component to scroll to the top of the page
// Should be hidden when the user is near the top of the page
import { computed } from 'vue';
import { useWindowScroll } from '@vueuse/core';

const { y } = useWindowScroll({ behavior: 'smooth' });

const showScrollTopButton = computed(() => y.value > 300);

function scrollTop() {
  y.value = 0;
}
</script>

<template>
  <!-- Div to add padding to the bottom of the page -->
  <div class="h-20">
    <Button
      class="!fixed bottom-8 right-8 !px-4 !py-4 !shadow-xl"
      aria-label="Scroll to top"
      v-show="showScrollTopButton"
      @click="scrollTop"
      rounded
      size="large"
    >
      <i class="icon-[line-md--arrow-up] rotate-90 text-2xl" />
    </Button>
  </div>
</template>
